import React from 'react';
import ReactSkeleton from 'react-loading-skeleton';
import Span from './../Span';
import './Skeleton.less';
export default class Skeleton extends React.Component {

    render() {
        return <Span className={`hms-skeleton ${this.props.className || ''}`}>
            <ReactSkeleton {...this.props} >{this.props.children}</ReactSkeleton>
        </Span>
    }
}